import React from "react"
import { UncontrolledTooltip, Button } from "reactstrap"
import { Link } from "react-router-dom"
import CopyToClipboard from "../Material/CopyToClipboard"
import { ReactComponent as CarEquipments } from '../assets/images/icons/car-equipments.svg'
import { ReactComponent as ReserveCar } from '../assets/images/icons/reserve-car.svg'
import { ReactComponent as LocationIcon } from '../assets/images/icons/location-icon.svg'
import renderEnumToInt from '../Functions/renderEnumToInt'

const CarInfoTooltip = ({ car, i, toggleModal, viewImages, setOpenModal }) => {
    if (!car || typeof i === "undefined" || !toggleModal || !viewImages || !setOpenModal) {
        return null
    }

    const tooltipId = `carPkTooltip${i}`
    const reservationExists = car.carReservation?.edges?.length > 0
    const checkoutImages = car.lastCheckout?.carpicturesSet?.edges?.length > 0
    const hasCheckout = !!car.lastCheckout

    return (
        <UncontrolledTooltip delay={{ show: 400, hide: 200 }} target={tooltipId} placement="right" autohide={false} className="bos-custom-tooltip">
            <label>
                {car.pk ? `#${car.pk}` : ""} - {car.carModel?.make || ""} {car.carModel?.name || ""}&nbsp;
                <Link to={`/car/${car.pk}`} target="_blank" className="text-primary">
                    <i className="fa fa-external-link fa-sm" style={{ fontSize: "0.75rem" }}></i>
                </Link>
            </label>
            <p className="bos-custom-tooltip-body">
                <div>
                    <b>VIN:</b> {car.vin || "--"} <CopyToClipboard textToCopy={car.vin || "--"} displayText="Vin" />
                </div>
                <b>Current Agreement: </b>
                {car.currentAgreement?.driver?.id ? (
                    <a href={`/driver/${car.currentAgreement.driver.id}`} target="_blank" rel="noopener noreferrer">
                        {car.currentAgreement.driver.name || "Unknown Driver"}
                    </a>
                ) : "--"}
                <br />
                <b>Branch:</b> {car.branch?.name || "--"}<br />
                <b>Stage:</b> {car.stage && car.stageDisplay ? `${renderEnumToInt(car.stage)} - ${car.stageDisplay}` : "--"}<br />
                <b>Group:</b> {car.carModel?.groupType?.name || "--"}<br />
                <b>Color:</b> {car.color || "--"}<br />
                <b>Location:</b> {car.location || "--"}<br />
                <b>Plate:</b> {car.dmvPlate || "--"}<br />
            </p>
            <span className="bos-custom-tooltip-footer">
                <Button size="sm" color="secondary" onClick={() => toggleModal("carDocuments" + i)} title="Open Car Documents">
                    <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                </Button>&nbsp;
                <Button size="sm" color="secondary" onClick={() => viewImages(car.lastCheckout, i)} title={checkoutImages ? "Checkout pictures" : hasCheckout ? "Checkout without picture" : "Needs checkout"}>
                    <i
                        className="fa fa-file-image-o"
                        style={{
                            color: checkoutImages ? "#28a745" : hasCheckout ? "#FFAA32" : "#DC3546"
                        }}
                        aria-hidden="true"
                    />
                </Button>&nbsp;
                <Button size="sm" color="secondary" onClick={() => toggleModal("carEquipments" + car.pk)} title="View Car Equipments">
                    <CarEquipments width={16} fill="#303e67" />
                </Button>&nbsp;
                <Button size="sm" color="secondary" onClick={() => setOpenModal(reservationExists ? "UpdateReservationModal" + i : "NewReservationModal" + i)} title={reservationExists ? "Edit Reservation" : "Create Reservation"}>
                    <ReserveCar width={20} fill={reservationExists ? "#28a745" : "#303E67"} />
                </Button>&nbsp;
                <Button id={`LocationPopup${i}`} size="sm" color="secondary" className="px-2" title="Locate car on FleetSync">
                    <a
                        href={`https://fleetsync.io/cars/${car.pk}?tab=Map`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                    >
                        <LocationIcon width={20} fill="#303E67" />
                    </a>
                </Button>&nbsp;
            </span>
        </UncontrolledTooltip>
    )
}

export default CarInfoTooltip
